<template>
  <div v-if="hasDiving()" class="container main__diving main--sticky-bottom">
    <el-dialog
      :show-close="true"
      :visible="wetSuitSizeDialogVisible"
      center
      custom-class="diving__size-dialog"
      @close="wetSuitSizeDialogVisible = false"
    >
      <template slot="title"
        ><h2 class="diving__size-dialog-title">Wetsuit Size Chart</h2>
      </template>
      <div class="diving__size-dialog-table-header">Adult</div>
      <el-table
        :data="adultWetSuitSizeData"
        :resizable="false"
        fit
        style="margin-bottom: 40px"
      >
        <el-table-column label="Sizes" prop="size"></el-table-column>
        <el-table-column label="Chest (cm)" prop="chest"></el-table-column>
        <el-table-column label="Waist (cm)" prop="waist"></el-table-column>
        <el-table-column label="Hip (cm)" prop="hip"></el-table-column>
        <el-table-column label="Height (cm)" prop="height"></el-table-column>
        <el-table-column label="Height (ft)" prop="heightFt"></el-table-column>
        <el-table-column label="Weight (kg)" prop="weightKg"></el-table-column>
      </el-table>

      <div class="diving__size-dialog-table-header">Children</div>
      <el-table :data="childWetSuitSizeData" :resizable="false" fit>
        <el-table-column label="Sizes" prop="size"></el-table-column>
        <el-table-column label="Chest (cm)" prop="chest"></el-table-column>
        <el-table-column label="Waist (cm)" prop="waist"></el-table-column>
        <el-table-column label="Hip (cm)" prop="hip"></el-table-column>
        <el-table-column label="Height (cm)" prop="height"></el-table-column>
        <el-table-column label="Height (ft)" prop="heightFt"></el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      :show-close="true"
      :visible="finSizeDialogVisible"
      center
      custom-class="diving__size-dialog diving__size-dialog--large"
      @close="finSizeDialogVisible = false"
    >
      <template slot="title"
        ><h2 class="diving__size-dialog-title">Fin Size Chart</h2></template
      >
      <el-table
        :data="finSizeData"
        :resizable="false"
        fit
        header-cell-class-name="dark"
        style="margin-bottom: 40px"
      >
        <el-table-column label="Sizes" prop="size"></el-table-column>
        <el-table-column label="US" prop="us"></el-table-column>
        <el-table-column label="UK" prop="uk"></el-table-column>
        <el-table-column label="Euro" prop="euro"></el-table-column>
        <el-table-column label="Inches" prop="inches"></el-table-column>
        <el-table-column label="CM" prop="cm"></el-table-column>
      </el-table>
    </el-dialog>
    <el-alert :closable="false" class="alert" show-icon title="" type="warning">
      <div class="alert__title">Important note:</div>
      <ul class="alert__list">
        <li>
          It is mandatory to present your diving certificate (PADI or
          equivalent) on board.
        </li>
        <li>
          It is highly recommended that you get a diving insurance or travel
          insurance that covers diving activity.
        </li>
        <div v-if="isAquaLares()">
          <li>
            Persons over 55 years of age should be in possession of a medical
            health clearance.
          </li>
          <li>
            Diving will be managed by a qualified dive guide for each group
            (estimated at 5 pax per group).
          </li>
        </div>
        <div v-else>
          <li>
            Please note that diving is available for 8 guests per session. There
            are 2 sessions per day.
          </li>
        </div>
      </ul>
    </el-alert>
    <el-collapse ref="formRoot" v-model="activeCollapseIndexes">
      <el-collapse-item
        v-for="(contactBooking, index) in contactBookings"
        :key="contactBooking.contactID"
        :name="index"
        class="el-collapse-item--diving"
      >
        <!--<div class="label-mandatory">fields with <span class="indicator-mandatory">*</span> are mandatory</div>-->
        <template slot="title" class="title">
          <span class="guest-number">GUEST {{ index + 1 }}/</span
          >{{ getFullNameByContactId(contactBooking.contactID) }}
        </template>
        <div
          v-if="!canDive(getContactByContactId(contactBooking.contactID))"
          class="underage-note"
        >
          <div class="underage-note__icon icon-chat"></div>
          <div class="underage-note__content">
            <div class="underage-note__title">
              Sorry, your child is not eligible to dive.
            </div>
            <div class="underage-note__message">
              Guests must be 8 years of age or above to dive.
            </div>
          </div>
        </div>
        <el-form
          v-if="canDive(contact(contactBooking.contactID))"
          :model="contactBooking"
          :rules="ruleValidate"
          label-position="left"
        >
          <el-radio-group
            :value="contactBooking.planningToDive === true ? true : false"
            class="diving__planning-to-dive"
            @input="
              onContactBookingInputChange(
                contactBooking.contactID,
                'planningToDive',
                $event,
              )
            "
          >
            <el-radio :label="true">
              <div>I am planning to dive.</div>
            </el-radio>
            <el-radio :label="false">
              <div>I am not planning to dive.</div>
            </el-radio>
          </el-radio-group>
          <div
            v-if="
              contactBooking.planningToDive === true ||
              contactBooking.planningToDive === 'true' ||
              false
            "
          >
            <el-alert
              :closable="false"
              class="alert"
              show-icon
              title=""
              type="warning"
            >
              <div class="alert__title">Are you certified to dive?</div>
              <div>
                I declare that the named guest is certified to dive. Guests
                without a valid diving certificate will not be allowed to dive.
              </div>
            </el-alert>
            <el-row :gutter="32">
              <el-col :span="6">
                <el-row :gutter="16">
                  <el-form-item label="Wetsuit size" prop="divingWetsuit">
                    <v-select
                      :options="selectDivingWetsuit"
                      :reduce="(item) => item.value"
                      :searchable="false"
                      :value="contactBooking.divingWetsuit"
                      filterable
                      label="label"
                      @input="
                        onContactBookingInputChange(
                          contactBooking.contactID,
                          'divingWetsuit',
                          $event,
                        )
                      "
                    >
                    </v-select>
                  </el-form-item>
                </el-row>
                <el-row
                  v-if="contactBooking.divingWetsuit === 'Other'"
                  :gutter="16"
                >
                  <el-form-item
                    label="Wetsuit size (other)"
                    prop="divingWetsuitOther"
                  >
                    <el-input
                      :rows="6"
                      :value="contactBooking.divingWetsuitOther"
                      placeholder=""
                      @input="
                        onContactBookingInputChange(
                          contactBooking.contactID,
                          'divingWetsuitOther',
                          $event,
                        )
                      "
                    />
                  </el-form-item>
                </el-row>
              </el-col>

              <el-col :span="6">
                <el-row :gutter="16">
                  <el-form-item label="Fin size" prop="divingFins">
                    <v-select
                      :options="selectDivingFins"
                      :reduce="(item) => item.value"
                      :searchable="false"
                      :value="contactBooking.divingFins"
                      filterable
                      label="label"
                      @input="
                        onContactBookingInputChange(
                          contactBooking.contactID,
                          'divingFins',
                          $event,
                        )
                      "
                    >
                    </v-select>
                  </el-form-item>
                </el-row>
                <el-row
                  v-if="contactBooking.divingFins === 'Other'"
                  :gutter="16"
                >
                  <el-form-item label="Fin size (other)" prop="divingFinsOther">
                    <el-input
                      :rows="6"
                      :value="contactBooking.divingFinsOther"
                      placeholder=""
                      @input="
                        onContactBookingInputChange(
                          contactBooking.contactID,
                          'divingFinsOther',
                          $event,
                        )
                      "
                    />
                  </el-form-item>
                </el-row>
              </el-col>
            </el-row>

            <div>
              <i class="icon icon-measurement diving__size-icon"></i>
              <span class="diving__size-links">
                Size charts:
                <a @click="wetSuitSizeDialogVisible = true">Wetsuit</a> /
                <a @click="finSizeDialogVisible = true">Fin</a>
              </span>
            </div>
            <hr class="" />

            <h3 style="margin-top: 0">
              Please tell us more about your diving experience
            </h3>

            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item
                  label="Experience level"
                  prop="divingExperienceLevel"
                >
                  <v-select
                    :options="selectDivingExperienceLevel"
                    :reduce="(item) => item.value"
                    :searchable="false"
                    :value="contactBooking.divingExperienceLevel"
                    filterable
                    label="label"
                    placeholder="Please select"
                    @input="
                      onContactBookingInputChange(
                        contactBooking.contactID,
                        'divingExperienceLevel',
                        $event,
                      )
                    "
                  >
                  </v-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item
                  label="Date of last dive"
                  prop="dateOfLastDiveMonth"
                >
                  <v-select
                    v-model="
                      modelDateOfLastDiveMonths[contactBooking.contactID]
                    "
                    :clearable="false"
                    :options="selectDateMonths"
                    :reduce="(item) => item.value"
                    class="vs--medium-height"
                    filterable
                    label="label"
                    placeholder="Month"
                    @input="
                      onInputDateChange(
                        contactBooking.contactID,
                        ' dateOfLastDiveMonth',
                        $event,
                        'dateOfLastDive',
                      )
                    "
                  >
                  </v-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="" prop="dateOfLastDiveYears">
                  <template slot="label">
                    <div style="visibility: hidden">.</div>
                  </template>
                  <v-select
                    v-model="modelDateOfLastDiveYears[contactBooking.contactID]"
                    :clearable="false"
                    :options="selectDateYears"
                    :reduce="(item) => item.value"
                    class="vs--medium-height"
                    filterable
                    label="label"
                    placeholder="Year"
                    @input="
                      onInputDateChange(
                        contactBooking.contactID,
                        ' dateOfLastDiveYear',
                        $event,
                        'dateOfLastDive',
                      )
                    "
                  >
                  </v-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="16">
              <el-col :span="9">
                <el-form-item
                  label="Diving Certification Number"
                  prop="divingCertificationNumber"
                >
                  <el-input
                    :rows="6"
                    :value="contactBooking.divingCertificationNumber"
                    placeholder="E.g 1405AA8733"
                    @input="
                      onContactBookingInputChange(
                        contactBooking.contactID,
                        'divingCertificationNumber',
                        $event,
                      )
                    "
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12"> </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="8">
                <el-form-item
                  label="Diving Association"
                  prop="divingAssociation"
                >
                  <v-select
                    :ref="'divingAssociationSelect' + contactBooking.contactID"
                    :clearable="false"
                    :options="selectDivingAssociation"
                    :reduce="(item) => item.value"
                    :searchable="false"
                    :value="retrieveDivingAssociationValue(contactBooking)"
                    filterable
                    label="label"
                    style="
                      width: 300px;
                      display: inline-block;
                      vertical-align: middle;
                    "
                    @input="
                      onContactBookingInputChange(
                        contactBooking.contactID,
                        'divingAssociation',
                        $event,
                      )
                    "
                    v-on:search:focus="
                      onDivingAssociationFocus(contactBooking.contactID)
                    "
                  >
                  </v-select>
                </el-form-item>
              </el-col>
              <el-col
                v-if="contactBooking.divingAssociation === 'Other'"
                :span="12"
              >
                <el-form-item
                  label="Please indicate the Diving Association"
                  prop="divingAssociationOther"
                >
                  <el-input
                    :rows="6"
                    :value="contactBooking.divingAssociationOther"
                    placeholder=""
                    @input="
                      onContactBookingInputChange(
                        contactBooking.contactID,
                        'divingAssociationOther',
                        $event,
                      )
                    "
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <hr />

            <h3 style="margin-top: 0">
              PADI Liability Release and Assumption of Risk
            </h3>
            <el-checkbox
              :value="contactBooking.HasSignedPADIReleaseOfLiability"
              @input="
                onContactBookingInputChange(
                  contactBooking.contactID,
                  'HasSignedPADIReleaseOfLiability',
                  $event,
                )
              "
            >
              I understand and agree to the terms of the
              <span class="rol-link" @click="handleClickROL"
                >PADI Liability Release and Assumption of Risk</span
              >.
            </el-checkbox>
          </div>
        </el-form>
      </el-collapse-item>
    </el-collapse>

    <div class="sticky-bottom">
      <el-row class="bottom-nav" justify="space-between" type="flex">
        <el-button
          :disabled="isSaving"
          class="button--secondary bottom-nav__secondaryButton"
          @click="onClickBack"
          >Back</el-button
        >

        <autosave-indicator />
        <el-button
          :disabled="isSaving"
          class="button--tertiary bottom-nav__secondaryButton"
          @click="onClickSaveAndExit(false)"
          >Save
        </el-button>
        <el-button
          :disabled="isSaving || checkAllSignedPADI(contactBookings)"
          class="button--primary bottom-nav__primaryButton"
          @click="onClickNext"
          >Next</el-button
        >
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import types from "../store/types";
import {
  ADULT_WETSUIT_SIZE_DATA,
  CHILD_WETSUIT_SIZE_DATA,
  DATE_MONTHS,
  DATE_YEARS,
  DIVING_ASSOCIATIONS,
  DIVING_EXPERIENCE_LEVEL,
  DIVING_FINS,
  DIVING_MASK,
  DIVING_WETSUIT,
  FACILITY_CODES,
  FIN_SIZE_DATA,
  UNHANDLED_ERROR_MESSAGE,
} from "../constants";
import contactMixin from "../mixins/contact";
import autosave from "../mixins/autosave";
import { timeTrack } from "../mixins/timeTrack";
import AutosaveIndicator from "./AutosaveIndicator";
import { delay, padTime, positionDropdown, waitUntil } from "../utils";

const DELIMITER = ";";

export default {
  props: {
    index: Number,
  },
  mixins: [contactMixin, timeTrack, autosave],
  components: { AutosaveIndicator },
  mounted() {
    this.initializeAutosave(
      this.onClickSaveAndExit.bind(this),
      this.$refs.formRoot,
    );
  },
  created() {
    gtag("set", "page_path", "/step-3b");
    gtag("event", "page_path", {
      path: "/step-3b",
    });
  },
  data() {
    const contacts = this.$store.getters["contacts"];
    const contactBookings = this.$store.getters["contactBookings"];

    // Creates a local model in order for Select multiple component to work
    // actual update state is done in onContactInputChange
    const validationConfig = {
      required: true,
      message: "Required",
      trigger: "change blur",
    };
    const ruleValidate = {};

    return {
      activeCollapseIndexes: this.index
        ? [this.index]
        : contacts.map((contact, index) => index),
      wetSuitSizeDialogVisible: false,
      finSizeDialogVisible: false,
      selectDivingWetsuit: DIVING_WETSUIT,
      selectDivingFins: DIVING_FINS,
      selectDivingMask: DIVING_MASK,
      selectDateMonths: DATE_MONTHS,
      selectDateYears: DATE_YEARS,
      selectDivingAssociation: DIVING_ASSOCIATIONS,
      modelDateOfLastDiveMonths: contactBookings.reduce(
        (accumulator, current) => {
          accumulator[current.contactID] = current.dateOfLastDive
            ? current.dateOfLastDive.split("-")[1]
            : "";
          return accumulator;
        },
        {},
      ),
      modelDateOfLastDiveYears: contactBookings.reduce(
        (accumulator, current) => {
          accumulator[current.contactID] = current.dateOfLastDive
            ? current.dateOfLastDive.split("-")[0]
            : "";
          return accumulator;
        },
        {},
      ),
      selectDivingExperienceLevel: DIVING_EXPERIENCE_LEVEL,
      adultWetSuitSizeData: ADULT_WETSUIT_SIZE_DATA,
      childWetSuitSizeData: CHILD_WETSUIT_SIZE_DATA,
      finSizeData: FIN_SIZE_DATA,
      ruleValidate,
    };
  },
  computed: {
    ...mapGetters([
      types.getters.contacts,
      types.getters.contact,
      types.getters.contactBookings,
      types.getters.booking,
      types.getters.isSaving,
    ]),
  },
  methods: {
    ...mapActions([
      types.actions.updateContactField,
      types.actions.updateContactBookingField,
      types.actions.updateBookingField,
      types.actions.updateContactsRemote,
      types.actions.updateContactsAndBookingRemote,
      types.actions.setIsVisibleDialogSaveAndExit,
    ]),
    getContactByContactId(contactID) {
      return this.contact(contactID);
    },
    retrieveDivingAssociationValue(contactBooking) {
      if (contactBooking.divingAssociation) {
        return contactBooking.divingAssociation;
      }
      this.onContactBookingInputChange(
        contactBooking.contactID,
        "divingAssociation",
        "PADI",
      );
      return "PADI";
    },
    onContactInputChange: function (contactID, fieldName, event) {
      console.log("[contactID, fieldName, event]", contactID, fieldName, event);

      const value = Array.isArray(event) ? event.join(DELIMITER) : event;
      this[types.actions.updateContactField]({
        contactID,
        fieldName,
        value,
      });
    },
    handleClickROL: function () {
      if (this.booking.facilityCode === FACILITY_CODES.AquaLares) {
        window.open("/AQL-PADI-Release.pdf", "_blank");
        return;
      }
      window.open("/AQB-PADI-Release.pdf", "_blank");
    },
    checkAllSignedPADI: function (contactBookings) {
      let isDiving = contactBookings.filter(
        (contact) => contact.planningToDive,
      );
      return isDiving.some(
        (contact) => contact.HasSignedPADIReleaseOfLiability === false,
      );
    },

    onContactBookingInputChange: async function (contactID, fieldName, event) {
      console.log("[contactID, fieldName, event]", contactID, fieldName, event);

      const value = Array.isArray(event) ? event.join(DELIMITER) : event;
      // The user can still edit the field while an autosave is happening,
      // so we should wait until the saving has completed before updating the field again
      await waitUntil(() => !this.isSaving);
      if (fieldName === "divingAssociation" && event !== "Other") {
        // Clear the Diving Association Other field
        this[types.actions.updateContactBookingField]({
          contactID,
          fieldName: "divingAssociationOther",
          value: "",
        });
      } else if (fieldName === "divingWetsuit" && event !== "Other") {
        // Clear the Diving Wetsuit Other field
        this[types.actions.updateContactBookingField]({
          contactID,
          fieldName: "divingWetsuitOther",
          value: "",
        });
      } else if (fieldName === "divingFins" && event !== "Other") {
        // Clear the Diving Fins Other field
        this[types.actions.updateContactBookingField]({
          contactID,
          fieldName: "divingFinsOther",
          value: "",
        });
      }

      this[types.actions.updateContactBookingField]({
        contactID,
        fieldName,
        value,
      });
    },

    onBookingInputChange: function (fieldName, event) {
      console.log("[fieldName, event]", fieldName, event);

      this[types.actions.updateBookingField]({
        fieldName,
        value: event,
      });
    },
    async onInputDateChange(
      contactID,
      fieldName,
      event,
      contactBookingFieldName,
    ) {
      console.log("[contactID, fieldName, event]", contactID, fieldName, event);

      let value = "";

      switch (contactBookingFieldName) {
        case "dateOfLastDive":
          value =
            this.modelDateOfLastDiveYears[contactID] &&
            this.modelDateOfLastDiveMonths[contactID]
              ? `${this.modelDateOfLastDiveYears[contactID]}-${padTime(this.modelDateOfLastDiveMonths[contactID])}-01`
              : "";
          break;
        default:
          console.warn(
            "Invalid contactBookingFieldName:",
            contactBookingFieldName,
          );
          return;
      }

      await waitUntil(() => !this.isSaving);
      this[types.actions.updateContactBookingField]({
        contactID,
        fieldName: contactBookingFieldName,
        value,
      });
    },
    async onDivingAssociationFocus(contactID) {
      const select = this.$refs[`divingAssociationSelect${contactID}`][0];
      await delay(1);
      const dropdown =
        select.$el.querySelector(".vs__dropdown-menu") ||
        document.querySelector(
          "body > .vs__dropdown-menu:not(.vs__fade-leave-active)",
        );
      if (!dropdown) {
        return;
      }
      positionDropdown(select.$el, dropdown);
      dropdown.style.width = "inherit";
    },
    async onClickSaveAndExit(isAutosaving = false) {
      try {
        const res = await this.saveDataToRemote(isAutosaving);
        if (isAutosaving) {
          return res;
        } else {
          this.setIsVisibleDialogSaveAndExit(true);
        }
      } catch (error) {
        this.$message.error(error.message || UNHANDLED_ERROR_MESSAGE);
        return false;
      }

      return true;
    },
    onClickNext: function () {
      this.saveDataToRemote()
        .then((res) => {
          this.$router.push("step-4");
        })
        .catch((error) => {
          this.$message.error(error.message || UNHANDLED_ERROR_MESSAGE);
        });
    },
    onClickBack: function () {
      this.saveDataToRemote()
        .then((res) => {
          this.$router.back();
        })
        .catch((error) => {
          this.$message.error(error.message || UNHANDLED_ERROR_MESSAGE);
        });
    },
    saveDataToRemote(isAutosave = false) {
      const { contacts, booking, contactBookings } = this;
      return this.updateContactsAndBookingRemote({
        contacts,
        booking,
        contactBookings,
        showLoader: !isAutosave,
        workflowTrigger: !isAutosave, // autosave keeps data fresh without firing Zoho triggers
      });
    },
  },
};
</script>

<style lang="scss">
@import "../scss/icon";
@import "../scss/typography";
@import "../scss/color";

.el-collapse-item__content {
  border-radius: 0 0 4px 4px;
  border: 1px solid $aqua-grey-75;
  border-width: 0 1px 1px 1px;
  padding-bottom: 30px;
}

.diving__size-dialog {
  min-width: 890px;

  &--large {
    min-width: 1016px;
  }

  .el-dialog__headerbtn {
    position: fixed;

    i {
      @extend .icon-close-white;
    }
  }

  .el-dialog__body {
    padding: 0 64px 64px 64px;

    table {
      text-transform: uppercase;
      margin-left: auto;
      margin-right: auto;

      th,
      td {
        padding-top: 8px;
        padding-bottom: 8px;
      }
    }

    .el-table__header {
      th {
        @include global-paragraph-small-bold;
        background-color: $aqua-grey-10;
        border-right: 1px solid #e7e7e7;
        color: #4a4a4a;

        &:first-child {
          border-left: 1px solid #e7e7e7;
        }
      }

      th.dark {
        @include global-paragraph-small-bold;
        background-color: $aqua-grey-100;
        border-right: 1px solid $aqua-grey-100;
        color: white;

        &:first-child {
          border-left: 1px solid $aqua-grey-100;
        }
      }
    }

    .el-table__body {
      td {
        border-right: 1px solid #e7e7e7;

        &:first-child {
          border-left: 1px solid #e7e7e7;
        }
      }
    }
  }
}

.el-collapse-item--diving {
  .el-collapse-item {
    &__header {
      padding-left: 114px;
    }
  }

  .guest-number {
    position: absolute;
    top: 50%;
    left: 40px;
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    transform: translateY(-50%);
  }

  .el-form-item__content {
    /*width: 60%;*/
  }

  .el-select ~ .el-textarea {
    margin-top: 16px;
  }
}
</style>
<style lang="scss" scoped>
@import "../scss/color";
@import "../scss/typography";

hr {
  margin-top: 48px;
  margin-bottom: 48px;
  border-top: 0;
  border-bottom: 1px solid $hr-color;
}

.h1-title {
  margin-bottom: 32px;
}

.special-request {
  padding: 48px 40px;
  background-color: #fff;

  .el-form-item__label {
    font-size: 20px;
    font-weight: normal;
    margin-bottom: 18px;
  }
}

.main__diving {
  h3 {
    @include typo-bold(20);
    margin-bottom: 32px;
  }
}

.alert {
  margin-bottom: 32px;

  &__title {
    @include typo-bold(16);
  }

  &__list {
    margin-top: 4px;
    margin-bottom: 0;
  }
}

.diving {
  &__planning-to-dive {
    padding: 24px 0;
  }

  &__size-icon {
    background-position-y: bottom;
  }

  &__size-dialog-title {
    @include typo-bold(24);
  }

  &__size-dialog-table-header {
    @include global-paragraph-medium-bold;
    background-color: $aqua-grey-100;
    color: white;
    padding: 8px 16px;
  }

  &__size-links {
    @include typo(16);
    margin-left: 24px;

    a {
      cursor: pointer;
    }
  }
}

.rol-link {
  color: $link-color;
}

.underage-note {
  border-radius: 4px;
  background-color: #ecf1f5;
  padding: 16px 32px;
  display: flex;
  align-items: center;

  &__icon {
    background-size: contain;
    margin-right: 32px;
  }

  &__content {
  }

  &__title {
    @include typo-bold(16);
  }

  &__message {
    @include typo(16);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DivingPage.vue